"use strict";
/*
 * Created on 21. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractEntityFilter_1 = require("../../core/model/overview/AbstractEntityFilter");
/**
 * Filter for Product-supplier ("Add product") overview page.
 * @author Radek Beran
 */


var SuppliedProductOverviewFilter =
/*#__PURE__*/
function (_AbstractEntityFilter) {
  _inherits(SuppliedProductOverviewFilter, _AbstractEntityFilter);

  /**
   * @param cmCategoryId id of category-manager-level category
   * @param cmCategoryIds ids of category-manager-level category
   * @param categoryPlanId id of category-plan-level category
   * @param categoryPlanIds ids of category-plan-level category
   * @param supplierId id of supplier
   * @param supplierIds ids of supplier
   * @param excludedProductIds product ids to exclude
   * @param phraseForSearch
   * @param textForSearch
   */
  function SuppliedProductOverviewFilter(cmCategoryId, cmCategoryIds, categoryPlanId, categoryPlanIds, supplierId, supplierIds, excludedProductIds, phraseForSearch, textForSearch) {
    var _this;

    _classCallCheck(this, SuppliedProductOverviewFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SuppliedProductOverviewFilter).call(this));
    _this.cmCategoryId = cmCategoryId;
    _this.cmCategoryIds = cmCategoryIds;
    _this.categoryPlanId = categoryPlanId;
    _this.categoryPlanIds = categoryPlanIds;
    _this.supplierId = supplierId;
    _this.supplierIds = supplierIds;
    _this.excludedProductIds = excludedProductIds;
    _this.phraseForSearch = phraseForSearch;
    _this.textForSearch = textForSearch;
    return _this;
  }

  return SuppliedProductOverviewFilter;
}(AbstractEntityFilter_1.AbstractEntityFilter);

exports.SuppliedProductOverviewFilter = SuppliedProductOverviewFilter;
SuppliedProductOverviewFilter.EMPTY = new SuppliedProductOverviewFilter();